// extracted by mini-css-extract-plugin
export var grayCircle = "_dd-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_dd-1";
export var selectedCircle = "_dd-2";
export var shippingOptionImage = "_dd-3";
export var shippingOptionWidgetPreview = "_dd-4";